export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString() : "—");

export const fmtLongDate = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    const weekday = d.toLocaleDateString("es-ES", { weekday: "long" });
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${weekday} ${day}-${month}-${year}`;
};

export const between = (d, from, to) => {
    if (!d) return false;
    const x = new Date(d).setHours(0, 0, 0, 0);
    const a = from ? new Date(from).setHours(0, 0, 0, 0) : null;
    const b = to ? new Date(to).setHours(0, 0, 0, 0) : null;
    if (a && x < a) return false;
    if (b && x > b) return false;
    return true;
};

export const todayStart = () => new Date().setHours(0, 0, 0, 0);
